import React, { useEffect, useRef, useState, useContext } from "react";

import { Toast } from "primereact/toast";
import { TabPanel, TabView } from "primereact/tabview";

import Card from "../../../Components/Card/Card";
import { getLabel } from "../../../Services/Language/LanguageService"; 
import { baseLang } from "../../../Lang/BaseLang";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext"; 
import { AuthContext } from "../../../Context/AuthContext/AuthContext"; 
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../Services/Config/ConfigService"; 
import CalendarWeek from "../../../Components/Form/CalendarWeek";
import { toastShow } from "../../../Services/ToastService"; 
import { getDatesProduccion } from "../../../Services/Moment/Luxon";

import { getRegistroMetricasPorFecha, getRegistroMetricasPorUsuario  } from "../../../API/IT/Metricas/MetricasRequest"; 

const RegistroMetricasScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [registroMetricas, setRegistroMetricas] = useState([]);
  const [registroMetricasUsuario, setRegistroMetricasUsuario] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [dates, setDates] = useState([new Date(), new Date()]);



  const getInfo = async () => {
    setLoading(true);
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Por favor, seleccione un rango de fechas válido."
      );
      setLoading(false)
      return;
    }
  
    const fechas = getDatesProduccion(dates);
    if(activeIndex === 0){
      const d = await getRegistroMetricasPorFecha(fechas)
      setRegistroMetricas(d);
    }else{
      const d = await getRegistroMetricasPorUsuario(fechas);
      setRegistroMetricasUsuario(d);
    }
    setLoading(false);
  };



  const columns = [
    {
      field: "IdRegistro",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      onCellDoubleClicked: ({ data }) => {},
    },
    {
      field: "IdMetrica",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
    },
    {
      field: "Fecha",
      header: "Fecha",
      headerEn: "Date",
      body: (rowData) => rowData.Fecha,
      className: "small",
    },
    {
      field: "Nombre",
      header: "Metrica",
      headerEn: "Metrica",
      className: "large",
      flex: 1,
      Sumary:'count'
    },
    {
      field: "Descripcion",
      header: "Descripcion",
      headerEn: "Descripcion",
      className: "large",
    },
    {
      field: "Menu",
      header: "Menu",
      headerEn: "Menu",
      className: "large",
    },
    {
      field: "UserName",
      header: "Usuario",
      headerEn: "User",
      className: "medium",
    },
    {
      field: "TYPE",
      header: "Tipo",
      headerEn: "Type",
      className: "Xsmall",
    },
    {
      field: "Rol",
      header: "Rol",
      headerEn: "Rol",
      className: "medium",
    },
    {
      field: "AccesosUsuario",
      header: "Accesos Usuario",
      headerEn: "User Access",
      className: "Xlarge",
    },
  ];

  const columns2 = [
    {
      field: "IdMetrica",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
    },
    {
      field: "Nombre",
      header: "Metrica",
      headerEn: "Metrica",
      className: "large",
      Sumary:'count'
    },
    {
      field: "CantidadAccesos",
      header: "Cant. Accesos",
      headerEn: "Qty. Access",
      className: "Xsmall",
      frozen: true,
      alignFrozen: "right",
      Format: 'Modal',
      Sumary:'sum',
    },
    {
      field: "Descripcion",
      header: "Descripcion",
      headerEn: "Descripcion",
      className: "Xlarge",
      flex: 1,
    },
    {
      field: "Menu",
      header: "Menu",
      headerEn: "Menu",
      className: "XXlarge",
    },
    {
      field: "UserName",
      header: "Usuario",
      headerEn: "User",
      className: "medium",
    },
    {
      field: "Rol",
      header: "Rol",
      headerEn: "Rol",
      className: "medium",
    },
  ];

  const table = {
    Columns: columns,
    Data: registroMetricas,
    loading: loading,
  };

  const table2 = {
    Columns: columns2,
    Data: registroMetricasUsuario,
    loading: loading,
    showModal: (e) => {},
  };


  useEffect(() => {
    setTitlePage(getLabel(baseLang, "regmetricas", config.language));
    getInfo();
  }, [activeIndex]);

  return (
    <div style={{ width: "100%", height: "100%", margin: "auto" }}>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones flex-wrap d-flex">
            <h3>{getLabel(baseLang, "regmetricas", config.language)}</h3>
            <CalendarWeek
              date={dates}
              setDate={setDates}
              buscar={getInfo}
              selectionMode="range"
            />
          </div>
        }
        contenido={
          <div className="mt-4">
            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header="Métricas">
                <div className="p-4" style={{ height: "83vh" }}>
                  <AgGrid table={table} />
                </div>
              </TabPanel>
              <TabPanel header="Métricas Por Usuario">
                <div className="p-4" style={{ height: "83vh" }}>
                  <AgGrid table={table2} />
                </div>
              </TabPanel>
            </TabView>
          </div>
        }
      />
    </div>
  );
};

export default RegistroMetricasScreen;
